import { HierarchyContext } from "contexts/HierarchyContext";
import { TlfContext } from "contexts/TlfContext";
import { useContext, useEffect } from "react";

/**
 * Sets the document title and warns about unsaved changes.
 *
 * @param title - The document title to set in the browser tab
 */
export const useDocumentTitle = (title: string) => {
  const hierarchyContext = useContext(HierarchyContext);
  const tlfContext = useContext(TlfContext);

  useEffect(() => {
    /**
     * Handles the beforeunload event to warn users about unsaved changes.
     *
     * @param event - The event object
     * @returns BeforeUnloadEvent)
     */
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (hierarchyContext?.changed || tlfContext?.changed) {
        event.preventDefault();
        event.returnValue = true; // Required for older browsers
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hierarchyContext?.changed, tlfContext?.changed]);

  useEffect(() => {
    document.title = title;
  }, [title]);
};
